<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
    >
        <stock-transaction-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>

    import StockTransactionProvider from "../../../../providers/StockTransactionProvider";
    
    import {CrudCreate, ClientError} from '@dracul/common-frontend'
    
    import StockTransactionForm from "../StockTransactionForm";
    
    


    export default {
        name: "StockTransactionCreate",
         
        components: { StockTransactionForm, CrudCreate },
        
        props:{
          open: {type: Boolean, default: true}
        },
        
        data() {
            return {
                title: 'delivery.stockTransaction.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    branch: null,
                    branchDestination: null,
                    operation: '',
                    reason: '',
                    items: [],
                    user: null
                }
            }
        },
        
        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    StockTransactionProvider.createStockTransaction(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.createStockTransaction)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

